import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import { WebinarType } from 'models/webinars';
import { UserSessionContext } from 'components/UserSession';
import WatchNowIcon from 'components/icons/WatchNow';
import ActionButton from './ActionButton';

const StyledBtnText = styled.div`
  margin-left: 10px;
`;

const WatchNowButton = ({
  id,
  name,
  url,
  kind,
  supportedStream,
}) => {
  const { t } = useTranslation();
  const { userSession } = useContext(UserSessionContext);
  const onWatchNowClick = useCallback(() => {
    // eslint-disable-next-line no-new
    new Promise((resolve) => {
      window.trackingItemToFirebase(userSession, 'Webinar', 'PlayWebinarVideo', kind === WebinarType.Live ? 'isLive' : 'onDemand', url || '', id, name);
      resolve(null);
    });
  }, [id, name, url]);
  return (
    <ActionButton
      onClick={onWatchNowClick}
      to={url}
      href={url}
      rel={!supportedStream ? 'noopener noreferrer' : undefined}
      target={!supportedStream ? '_blank' : undefined}
      component={supportedStream ? Link : 'a'}
    >
      <WatchNowIcon color="#FFF" />
      <StyledBtnText>
        {kind === WebinarType.Live ? t('webinar.session.live') : t('webinar.session.play')}
      </StyledBtnText>
    </ActionButton>
  );
};

WatchNowButton.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  kind: PropTypes.oneOf([WebinarType.Live, WebinarType.OnDemand]).isRequired,
  supportedStream: PropTypes.bool,
};

WatchNowButton.defaultProps = {
  supportedStream: false,
};

export default WatchNowButton;
